import React, { Fragment } from 'react';
import styled from 'styled-components';
import rangeRight from 'lodash/rangeRight';
import PropTypes from 'prop-types';

import starFilled from '../../images/star-filled.svg';
import starEmpty from '../../images/star-empty.svg';

const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
 `;

const StarLabel = styled.label`
  width: ${(props) => props.starsWidth || 30}px;
  height: ${(props) => props.starsHeight || 20}px;
  cursor: pointer;
  background: url(${starEmpty}) no-repeat 0 0;
  background-size: contain;
  margin: 0;
  
  &:hover,
  &:hover ~ & {
    background-image: url(${starFilled});
  }
`;

const StarRadio = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1; 
  
  &:checked ~ ${StarLabel} {
    background-image: url(${starFilled});
  }
`;

const StarRating = (props) => {
  const {
    onStarClick, starsAmount, name, selectedStars, starsHeight, starsWidth,
  } = props;

  return (
    <Container>
      {rangeRight(starsAmount).map((i) => (
        <Fragment key={i}>
          <StarRadio
            className="star-radio"
            type="radio"
            name={name}
            value={i + 1}
            id={`star${i}`}
            onChange={onStarClick}
            checked={selectedStars === `${i + 1}`}
            data-test-selector={`form-field-${name}`}
          />
          <StarLabel className="star-label" htmlFor={`star${i}`} starsHeight={starsHeight} starsWidth={starsWidth} />
        </Fragment>
      ))}
    </Container>
  );
};

StarRating.propTypes = {
  starsAmount: PropTypes.number,
  onStarClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  selectedStars: PropTypes.string,
  starsHeight: PropTypes.number,
  starsWidth: PropTypes.number,
};

StarRating.defaultProps = {
  starsAmount: 5,
  selectedStars: 0,
  starsHeight: 20,
  starsWidth: 30,
};

export { StarRating };
